import { checkValueTypeUsesVariable } from '../../utilities';
import { ModifyRelatedEntriesStep } from '../actionSectionTypes';
import { FieldsToModify } from './types';

export const modifyRelatedEntitiesRemoveVariable = (
  step: ModifyRelatedEntriesStep,
  variableName: string,
  errorIds: string[]
) => {
  let hasError = step.hasError || false;
  const nextErrorIds: string[] = [];

  const recordSourceVariables = step.details.recordSourceVariables.map(
    (variable) => {
      if (variable.label !== variableName) {
        return variable;
      }

      if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
        hasError = true;
        nextErrorIds.push(step.id);
      }

      return { ...variable, deleted: true };
    }
  );

  const fieldsToModify = step.details.fieldsToModify.map(
    (fieldToModify: FieldsToModify) => {
      if (
        fieldToModify.variable?.value !== variableName ||
        !checkValueTypeUsesVariable(fieldToModify.valueType?.value)
      ) {
        return fieldToModify;
      }

      if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
        hasError = true;
        nextErrorIds.push(step.id);
      }
      return {
        ...fieldToModify,
        variable: { ...fieldToModify.variable, deleted: true },
      };
    }
  );

  return {
    nextStep: {
      ...step,
      details: { ...step.details, fieldsToModify, recordSourceVariables },
      hasError,
    },
    nextErrorIds,
  };
};
